<div class="d-flex align-items-center container-fluid">
    <div class="w-100 d-inline-flex align-items-center container-fluid">
        <ng-container
            *ngIf="_activeGridModel && _activeGridModel?.rows?.length !== 0"
        >
            <div class="my-2 mr-2">
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsOverlayTrigger]="filterTpl"
                    [cmpsTooltipTrigger]="_i18n._9979_FILTER_GRID | translate"
                    trigger="hover"
                    (click)="_toggleDisplayPillarFilterClick($event)"
                >
                    <cmps-icon svgIcon="sort-variant"></cmps-icon>
                </button>
            </div>
            <cmps-slide-bar class="cmps-slide-bar-container">
                <cmps-chip-list class="d-block">
                    <ng-container *ngFor="let p of _filterPillarList">
                        <cmps-chip
                            variant="b"
                            [selectable]="false"
                            [style.background]="slideBarColour"
                            *ngIf="p.isSelected"
                        >
                            <span>{{
                                p.label == null || p.label === ''
                                    ? '-'
                                    : (p.label | translate)
                            }}</span>
                            <button
                                class="cmps-icon-button--no-bg cmps-icon-button--sm cmps-icon-button--no-bg--white"
                                cmpsIconButton
                                (click)="_onSelectionClick(p)"
                            >
                                <cmps-icon svgIcon="close"></cmps-icon>
                            </button>
                        </cmps-chip>
                    </ng-container>
                </cmps-chip-list>
            </cmps-slide-bar>
            <ng-template
                let-overlay="overlay"
                #filterTpl
            >
                <cmps-filter
                    [overlay]="overlay"
                    (filterButtonClick)="_onFilterOptionItem($event)"
                    #filter
                >
                    <cmps-filter-header-label>{{
                        _i18n._7360_FILTER | translate
                    }}</cmps-filter-header-label>

                    <ng-container *ngFor="let cc of _filterCategories">
                        <cmps-filter-category-header *ngIf="cc[2]">{{
                            cc[1] | translate
                        }}</cmps-filter-category-header>
                        <cmps-filter-category-body>
                            <cmps-chip-list>
                                <ng-container
                                    *ngFor="let c of _onFilterSelectionCopy"
                                >
                                    <button
                                        cmpsChip
                                        [value]="c"
                                        [selected]="c.isSelected"
                                        [disabled]="c.disabled"
                                        *ngIf="c.category === cc[0]"
                                    >
                                        <span>{{
                                            c.label == null || c.label === ''
                                                ? '-'
                                                : (c.label | translate)
                                        }}</span>
                                    </button>
                                </ng-container>
                            </cmps-chip-list>
                        </cmps-filter-category-body>
                    </ng-container>

                    <button
                        class="w-100"
                        cmpsButton
                        [disabled]="!filter.selectionChanged"
                        (click)="_onApplyFilterOptionClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._9864_APPLY_FILTER | translate
                        }}</span>
                    </button>
                </cmps-filter>
            </ng-template>
        </ng-container>
    </div>
</div>
<cmps-direct-report-contribution-grid
    #contribution
    [model]="state?.directReportContributionGrid"
    (expandColumns)="_onExpandClick($event)"
    (sortChange)="_onDirectReportContributionSortChange($event)"
    (onGridSelect)="_onGridSelect($event)"
    (onDRSCSelect)="_onScorecardDRSelect($event)"
    *ngIf="activeTab === 'contributionView'"
>
</cmps-direct-report-contribution-grid>
<cmps-direct-report-rank-grid
    #RankView
    [model]="state?.directReportRankGrid"
    (sortChange)="_onDirectReportRankSortChange($event)"
    (onGridSelect)="_onGridSelect($event)"
    (onDRSCSelect)="_onScorecardDRSelect($event)"
    *ngIf="activeTab === 'rankView'"
>
</cmps-direct-report-rank-grid>
<cmps-direct-report-scorecard-grid
    #SCView
    [model]="state?.directReportScorecardGrid"
    (sortChange)="_onDirectReportScorecardSortChange($event)"
    (onGridSelect)="_onGridSelect($event)"
    (expandColumns)="_onExpandScorecardClick($event)"
    (onDRSCSelect)="_onScorecardDRSelect($event)"
    *ngIf="activeTab === 'directReportsView'"
>
</cmps-direct-report-scorecard-grid>
